export const marketplaceListingsContract = {
  _format: 'hh-sol-artifact-1',
  contractName: 'Marketplace',
  sourceName: 'contracts/Marketplace.sol',
  abi: [
    {
      inputs: [],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721AddressExists',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721AddressNotAdded',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721AddressNotAllowed',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ERC721ZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__FeeZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__InvalidListingId',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__InvalidPrice',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ListingAlreadyCancelled',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ListingNotActive',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NFTNotApprovedForMarketplaceContract',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NFTNotOwnedByMsgSender',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NftAlreadyListed',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotEnoughPaymentTokenApproved',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotOwnerOrSellerOrAllowedColletion',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotSeller',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__OwnerZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__RoyaltyZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__SellerCannotBuy',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__TokenZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ZeroPrice',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__ArrayLengthMismatch',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__BidAmountZero',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__BidNotActive',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__NotBidder',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__BidderCannotBeSeller',
      type: 'error',
    },
    {
      inputs: [],
      name: 'Marketplace__InsufficientBidderAllowance',
      type: 'error',
    },
    {
      inputs: [],
      name: 'OwnablePausable__OwnerAccountZeroAddress',
      type: 'error',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: '__nftContract',
          type: 'address',
        },
      ],
      name: 'AddressAdded',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: '__nftContract',
          type: 'address',
        },
      ],
      name: 'AddressRemoved',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'seller',
          type: 'address',
        },
      ],
      name: 'Canceled',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint8',
          name: 'version',
          type: 'uint8',
        },
      ],
      name: 'Initialized',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'seller',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'nftContract',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'price',
          type: 'uint256',
        },
      ],
      name: 'Listed',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Paused',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'price',
          type: 'uint256',
        },
      ],
      name: 'PriceUpdated',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'buyer',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'seller',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'price',
          type: 'uint256',
        },
      ],
      name: 'Sale',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'Unpaused',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'bidId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'bidder',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'BidPlaced',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'bidId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'bidder',
          type: 'address',
        },
      ],
      name: 'BidCancelled',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'uint256',
          name: 'bidId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'listingId',
          type: 'uint256',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'bidder',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'BidAccepted',
      type: 'event',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
      ],
      name: 'addAllowedContract',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_price',
          type: 'uint256',
        },
      ],
      name: 'buyNFT',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
      ],
      name: 'cancelListing',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
      ],
      name: 'cancelListing',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_startIdInclusive',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_limit',
          type: 'uint256',
        },
      ],
      name: 'getActiveCollectionListingsPage',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing[]',
          name: '',
          type: 'tuple[]',
        },
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_startId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_endId',
          type: 'uint256',
        },
      ],
      name: 'getActiveListingsInRange',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
      ],
      name: 'getAllActiveCollectionListings',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_startId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_endId',
          type: 'uint256',
        },
        {
          internalType: 'bool',
          name: '_onlyActive',
          type: 'bool',
        },
      ],
      name: 'getCollectionListingsInRange',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
      ],
      name: 'getListingByListingId',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing',
          name: '',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
      ],
      name: 'getListingByTokenId',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing',
          name: '',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'getListingCount',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_bidId',
          type: 'uint256',
        },
      ],
      name: 'getBid',
      outputs: [
        {
          components: [
            {
              internalType: 'address',
              name: 'bidder',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'amount',
              type: 'uint256',
            },
            {
              internalType: 'bool',
              name: 'active',
              type: 'bool',
            },
            {
              internalType: 'uint256',
              name: 'bidId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Bid',
          name: '',
          type: 'tuple',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
      ],
      name: 'getListingBids',
      outputs: [
        {
          components: [
            {
              internalType: 'address',
              name: 'bidder',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'amount',
              type: 'uint256',
            },
            {
              internalType: 'bool',
              name: 'active',
              type: 'bool',
            },
            {
              internalType: 'uint256',
              name: 'bidId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Bid[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
      ],
      name: 'getActiveListingBids',
      outputs: [
        {
          components: [
            {
              internalType: 'address',
              name: 'bidder',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'amount',
              type: 'uint256',
            },
            {
              internalType: 'bool',
              name: 'active',
              type: 'bool',
            },
            {
              internalType: 'uint256',
              name: 'bidId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Bid[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_user',
          type: 'address',
        },
      ],
      name: 'getActiveUserBids',
      outputs: [
        {
          components: [
            {
              internalType: 'address',
              name: 'bidder',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'amount',
              type: 'uint256',
            },
            {
              internalType: 'bool',
              name: 'active',
              type: 'bool',
            },
            {
              internalType: 'uint256',
              name: 'bidId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Bid[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
      ],
      name: 'getListingIdByToken',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_startId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_endId',
          type: 'uint256',
        },
        {
          internalType: 'bool',
          name: '_onlyActive',
          type: 'bool',
        },
      ],
      name: 'getListingIdsInRange',
      outputs: [
        {
          internalType: 'uint256[]',
          name: '',
          type: 'uint256[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256[]',
          name: '_listingIds',
          type: 'uint256[]',
        },
      ],
      name: 'getListingsBatch',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_seller',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_startId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_endId',
          type: 'uint256',
        },
        {
          internalType: 'bool',
          name: '_onlyActive',
          type: 'bool',
        },
      ],
      name: 'getUserListingsInRange',
      outputs: [
        {
          components: [
            {
              internalType: 'bool',
              name: 'listed',
              type: 'bool',
            },
            {
              internalType: 'bool',
              name: 'sold',
              type: 'bool',
            },
            {
              internalType: 'address',
              name: 'seller',
              type: 'address',
            },
            {
              internalType: 'address',
              name: 'nftContract',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'tokenId',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'price',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'listingId',
              type: 'uint256',
            },
          ],
          internalType: 'struct IMarketplace.Listing[]',
          name: '',
          type: 'tuple[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_owner',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_paymentToken',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_revenueWallet',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_royaltyAddress',
          type: 'address',
        },
      ],
      name: 'initialize',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
      ],
      name: 'isAllowedContract',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
      ],
      name: 'isListed',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address[]',
          name: '_nftContracts',
          type: 'address[]',
        },
        {
          internalType: 'uint256[]',
          name: '_tokenIds',
          type: 'uint256[]',
        },
      ],
      name: 'isListedBatch',
      outputs: [
        {
          internalType: 'bool[]',
          name: '',
          type: 'bool[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
      ],
      name: 'isListingActive',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_tokenId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_price',
          type: 'uint256',
        },
      ],
      name: 'listNFT',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'maxListingId',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'pause',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paused',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paymentToken',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_nftContract',
          type: 'address',
        },
      ],
      name: 'removeAllowedContract',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'revenueWallet',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'royaltyAddress',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'unpause',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_listingId',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_price',
          type: 'uint256',
        },
      ],
      name: 'updateListingPrice',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ],
  bytecode:
    '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',
  deployedBytecode:
    '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',
  linkReferences: {},
  deployedLinkReferences: {},
}
